// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2063f181","453":"635e0796"}[chunkId] + ".chunk.js";
};